var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar",class:[{'avatar--image': _vm.image, 'avatar--text': !_vm.image && _vm.text}, 'scheme--' + _vm.type]},[(_vm.image)?_c('img',{staticClass:"avatar__image",attrs:{"src":_vm.image}}):(_vm.text)?_c('span',{staticClass:"avatar__text"},[_vm._v(" "+_vm._s(_vm.firstChar)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }